import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "preview-form"
}
const _hoisted_2 = { class: "final-preview" }
const _hoisted_3 = { class: "final-preview-inner" }
const _hoisted_4 = { class: "preview-title" }
const _hoisted_5 = { class: "iframe-container" }
const _hoisted_6 = ["src", "height"]
const _hoisted_7 = { class: "publish-form-container" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("canvas", { id: "preview-barcode-container" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_styled_uploader = _resolveComponent("styled-uploader")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_drawer = _resolveComponent("a-drawer")!

  return (_ctx.visible)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.pageState.title), 1),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("iframe", {
                src: _ctx.previewURL,
                width: "375",
                frameborder: "0",
                class: "iframe-placeholder",
                height: _ctx.pageState.props && _ctx.pageState.props.height ? _ctx.pageState.props.height : '560'
              }, null, 8, _hoisted_6)
            ])
          ])
        ]),
        _createVNode(_component_a_drawer, {
          title: "设置面板",
          placement: "right",
          width: "400",
          closable: true,
          visible: _ctx.visible,
          onClose: _ctx.onCancel
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_a_row, {
                type: "flex",
                align: "middle",
                style: { marginBottom: '20px' }
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, { span: 6 }, {
                    default: _withCtx(() => [
                      _createTextVNode(" 扫码预览： ")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, { span: 10 }, {
                    default: _withCtx(() => [
                      _hoisted_8
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_row, {
                type: "flex",
                align: "middle",
                style: { marginBottom: '20px' }
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, { span: 6 }, {
                    default: _withCtx(() => [
                      _createTextVNode(" 上传封面： ")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, { span: 10 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_styled_uploader, {
                        text: "上传封面",
                        uploaded: _ctx.form.uploaded,
                        "show-uploaded": "",
                        onSuccess: _ctx.updateAvatar
                      }, null, 8, ["uploaded", "onSuccess"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_form, {
                "label-col": { span: 6 },
                "wrapper-col": { span: 16 },
                model: _ctx.form,
                rules: _ctx.rules
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_form_item, {
                    label: "标题",
                    required: "",
                    name: "title"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: _ctx.form.title,
                        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.title) = $event))
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_form_item, {
                    label: "描述",
                    required: "",
                    name: "desc"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: _ctx.form.desc,
                        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.desc) = $event))
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_form_item, { "wrapper-col": { span: 18, offset: 4 } }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_button, {
                        type: "primary",
                        class: "ml-3",
                        loading: _ctx.saveIsLoading,
                        onClick: _ctx.validateAndSave
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" 保存 ")
                        ]),
                        _: 1
                      }, 8, ["loading", "onClick"]),
                      _createVNode(_component_a_button, {
                        class: "ml-3",
                        onClick: _ctx.onCancel
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" 取消 ")
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model", "rules"])
            ])
          ]),
          _: 1
        }, 8, ["visible", "onClose"])
      ]))
    : _createCommentVNode("", true)
}